import script from "./InicioView.vue?vue&type=script&setup=true&lang=js"
export * from "./InicioView.vue?vue&type=script&setup=true&lang=js"

import "./InicioView.vue?vue&type=style&index=0&id=64fc2e76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64fc2e76"]])

export default __exports__